module.exports = __webpack_public_path__ + "fonts/fontello-6ca0253cd9b16fcb5dcf9e7f7ca6c1ef.woff";


//////////////////
// WEBPACK FOOTER
// ./src/shared/fontello/font/fontello.woff
// module id = 581
// module chunks = business-manager/video-library-page full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings